import { Component, Input } from '@angular/core';
import { QuestionnaireProcessStep } from 'src/app/common/enums';
import { WorkerProfile } from 'src/app/models/WorkerProfile';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  standalone: false
})
export class ContactInfoComponent {
  @Input('workerProfile') profile: WorkerProfile;
  questionnaireProcessStep = QuestionnaireProcessStep;
  constructor() { }
}
